import * as types from '../types/pickUpTime';

export default function PickUpTime(state = {
  selectedOption: {},
  availableTimes: [],
  serverTime: ''
}, action) {
  switch (action.type) {
    case types.SET_OPTION:
      return {
        ...state,
        selectedOption: action.data,
      };
    case types.CALC_TIMES:
      return {
        ...state,
        availableTimes: action.data
      };
    case types.SET_SERVER_TIME:
      return {
        ...state,
        serverTime: action.data
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/pickUpTime.js